import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from 'src/app/unsaved-changes.guard';

@Component({
  selector: 'app-sus-wrapper',
  templateUrl: './sus-wrapper.component.html',
  styleUrls: ['./sus-wrapper.component.scss']
})
export class SusWrapperComponent implements OnInit, CanComponentDeactivate {

  dirty = false;

  constructor() { }

  ngOnInit(): void {
  }

  setDirty(value) {
    this.dirty = value;
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return !this.dirty;
  }

}
